import autoBind from 'react-autobind';
import {Map} from 'immutable';

import React, {Component, PropTypes} from 'react';

export default class Comment extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  commentText() {
    const {model} = this.props;

    return model.get('text').split('\n').map((text, index) =>
      <div key={index}>{text}<br /></div>);
  }

  render() {
    const {model} = this.props;

    return (
      <div className="community-comment">
        <div className="submitter-information">
          <div className="submitter-name">{model.get('submitterName')}</div>
          <div className="submitter-school">{model.get('submitterSchool')}</div>
          <div className="submitted-at">{model.get('createdAt')}</div>
        </div>
        <div className="comment-text">{this.commentText()}</div>
      </div>
    );
  }
}

Comment.propTypes = {
  model: PropTypes.instanceOf(Map).isRequired,
};



// WEBPACK FOOTER //
// ./app/features/comments/components/Comment.js